<template>
  <div class="user-search-general-statistics">
    <userSearchStatisticTemplate :isFavorite="isFavorite" @total-count="setTotalCount" statisticType="generalStatistic"/>
  </div>
</template>
<style lang="scss" scoped>
</style>
<script>
import userSearchStatisticTemplate from "./UserSearchStatisticTemplate";

export default {
  name: "UserSearchGeneralStatistics",
  components: {
    userSearchStatisticTemplate,
  },
  props: {
    isFavorite: {
      type: Boolean,
      default: true,
    },
  },
  data() {
      return {
          totalCount: 0,
      };
  },
  methods: {
    setTotalCount(totalCount) {
        this.totalCount = totalCount;
        this.$emit('total-count', this.totalCount);
    },
  },
};
</script>